import { render, staticRenderFns } from "./facerecord.vue?vue&type=template&id=d6871808"
import script from "./facerecord.vue?vue&type=script&lang=js"
export * from "./facerecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports